import React, { Fragment } from "react";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import Image from "react-bootstrap/Image";

import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingLink,
  ReusableOnboardingButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import Media from "react-media";

const VendorMapSetupScreenTwoWrapper = ({ localProps, state, ...props }) => {
  return (
    <Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation
              leftText="vendorReview"
              backButtonLink="/profile"
              displayText="Back"
            />
            <div id="onboarding-scrollbar" className="col-6">
              <div>
                <div>
                  <TopTextReusableComponent
                    headingText="Map Setup"
                    headingParagraph="Restaurant names on Amealio need to be written as they appear on the board outside the restaurant"
                    displayEdit={state.editButton}
                    onClickEdit={localProps.editClick}
                  />
                </div>
                <div className="onboarding-map-setup-screen-inside-map d-flex align-items-center justify-content-between mt-3 mb-3">
                  <h5 className="f12-400">
                    Drop a pin to your address Move the marker as required
                  </h5>
                  <div className="d-flex align-items-center justify-content-end">
                    <div
                      className="d-flex align-items-center"
                      onClick={localProps.onAutoDetectHandler}
                    >
                      <Image
                        src={require("../../../../assets/images/UserManagement/map-pin-red.svg")}
                        fluid
                        alt="Auto Detect"
                        title="Auto Detect"
                        className="location-detections-popup-map-search"
                      />
                      <p className="f14-500" style={{ color: "#EE3A23" }}>
                        {/* onboarding-map-setup-paragraphtext */}
                        Auto Detect Location
                      </p>
                    </div>
                  </div>
                </div>

                {props.children}
                <div className="onboarding-map-setup-screen-autodetect-button">
                  {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
                  <ReusableOnboardingLink
                    buttonTitle="Cancel Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Cancel"
                    link="/profile"
                  />
                  {state.editButton === true ? (
                    <ReusableOnboardingButton
                      buttonTitle="Save Button"
                      buttonText="Save"
                      buttonType="button"
                      disabled={state.actionButton === false ? true : false}
                      onClick={
                        state.actionButton === false
                          ? null
                          : localProps.onSubmitHandler
                      }
                      buttonClass={
                        state.actionButton === false
                          ? "onboarding_button_link_reusable onboarding_button_link_reusable_white ml-3"
                          : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      }
                    />
                  ) : null}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
          <Media query="(max-width: 991px)">
            <div className="bottom-panel">
              <BottomNavigationMobile />
            </div>
          </Media>
        </div>
      </div>
    </Fragment>
  );
};

export default VendorMapSetupScreenTwoWrapper;
//14-09-2020
